<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item label="请假事由" prop="title">
							<el-input placeholder="关键字" v-model="formInline.title"></el-input>
						</el-form-item>
						<el-form-item label="审批结果" prop="status">
							<el-select placeholder="状态" v-model="formInline.status">
								<el-option label="请选择" value=""></el-option>
								<el-option label="待审批" value="1"></el-option>
								<el-option label="已通过" value="2"></el-option>
								<el-option label="已拒绝" value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时间"  prop="date">
							<el-date-picker type="daterange" v-model="formInline.date" :disabled-date="disabledDate"
								value-format="YYYY-MM-DD"></el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button @click="seachFun" type="primary">{{ $t('device.inquire') }}</el-button>
							<el-button @click="resetFun" type="primary">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-button @click="addUser" type="primary" v-if="$store.state.pageAction.indexOf('message.add')> -1">
					{{ $t('device.add') }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="申请人" prop="user_name" width="160">
					<template #default="{ row }">
						<div style="white-space: nowrap;">
							<div>{{ row.user_name}}</div>
							<div>{{row.user_mobile}}</div>
							<div style="color:crimson; font-size: 12px;">({{row.role_name}})</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="请假类型" prop="leave_type_title" width="120"></el-table-column>
				<el-table-column label="开始时间" prop="start_date" width="160"></el-table-column>
				<el-table-column label="结束时间" prop="end_date" width="160"></el-table-column>
				<el-table-column label="请假事由">
					<template #default="scope">
						{{ truncateText(scope.row.content,  300) }}
					</template>
				</el-table-column>
				<el-table-column label="审批结果" prop="status_title" width="120"></el-table-column>
				<el-table-column label="审批人" prop="user_name" width="160">
					<template #default="{ row }">
						<div style="white-space: nowrap;">
							<div>
								{{ row.record_list  && row.record_list.length  > 0 ? row.record_list[0].approve_name:''}}
							</div>
							<div>{{ row.record_list  && row.record_list.length  > 0 ? row.record_list[0].create_at:''}}
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="提交时间" prop="create_at" width="160"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="140">
					<template #default="scope">
						<el-button @click="handleApprove(scope.row)" type="primary" size="small"
							v-if="scope.row.status==1&&$store.state.pageAction.indexOf('leave.approve')> -1">审批
						</el-button>
						<el-button @click="handleEdit(scope.row)" type="primary" size="small"
							v-if="scope.row.status>1&&$store.state.pageAction.indexOf('leave.edit')> -1">查看
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 200]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="审批" top="30vh" v-model="addPop" width="50%">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item label="请假事由" label-width="120px" prop="content">
						<el-input type="textarea" rows="4" v-model="addForm.content"></el-input>
					</el-form-item>
				</el-form>
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item label="审批结果" label-width="120px" prop="approve_status">
						<el-select placeholder="请选择" v-model="addForm.approve_status" style="width:60px !important;">
							<el-option :key="item.value" :label="item.label" :value="item.value"
								v-for="item in statusOpts"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item label="审批意见" label-width="120px" prop="comment">
						<el-input type="textarea" rows="4" v-model="addForm.comment"></el-input>
					</el-form-item>
				</el-form>
				<el-form :model="addForm" ref="addForm" v-if="addForm.approve_uid>0">
					<el-form-item label="审批人" label-width="120px" prop="approve_name">
						{{addForm.approve_name}}
					</el-form-item>
					<el-form-item label="审批时间" label-width="120px" prop="approve_time">
						{{addForm.approve_time}}
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer" v-if="addForm.status==1">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
	import message from "../../model/leave";

	export default {
		name: "user",
		data() {
			return {
				dialogFormVisible: false,
				formInline: {
					title: "",
					status: "",
					data: [],
					page: 1,
					size: 10
				},
				resetform: {
					uid: "",
					title: "",
					password: ""
				},
				listCount: 0,
				appData: [],
				addPop: false,
				addForm: {
					status: "",
					title: "",
					content: "",
					comment: "",
					approve_uid: "",
					approve_name: ""
				},
				statusOpts: [{
					label: '通过',
					value: 2
				}, {
					label: '拒绝',
					value: 3
				}],
				roleOpts: [],
				rules: {
					approve_status: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					comment: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
		},
		methods: {
			truncateText(text, limit) {
				return text?.length > limit ? `${text.substr(0,  limit)}...` : text || '-';
			},
			resetFun() {
				this.formInline.title = ''
				this.formInline.status = ''
				this.formInline.date = []
				this.loadData()
			},
			async loadData() {
				const ret = await message.list(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm))
						const ret = await message.approve(params)
						if (ret.code === 200) {
							this.addPop = false
							this.$message.success(ret.message)
							this.loadData()
						} else {
							this.$message.warning(ret.message)
						}
					} else {
						return false;
					}
				});
			},
			async handleStatus(row) {
				const ret = await message.status({
					uid: row.uid,
					status: row.status == 1 ? 2 : 1
				})
				if (ret.code === 200) {
					this.$message.success(ret.message)
					this.loadData()
				} else {
					this.$message.warning(ret.message)
				}
			},
			seachFun() {
				this.loadData();
			},
			addUser() {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					this.addForm = {
						status: "",
						comment: "",
					}
				})
			},
			handleApprove(row) {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					let rowData = JSON.parse(JSON.stringify(row))
					this.addForm.content = rowData.content
					this.addForm.status = rowData.status
					this.addForm.id = rowData.id
				})
			},
			handleEdit(row) {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					let rowData = JSON.parse(JSON.stringify(row))
					this.addForm.content = rowData.content
					this.addForm.status = rowData.status
					this.addForm.id = rowData.id

					const record = rowData.record_list && rowData.record_list.length > 0 ? rowData.record_list[0] :
					{};

					this.addForm.comment = record.comment
					this.addForm.approve_status = record.status
					this.addForm.approve_uid = record.approve_uid
					this.addForm.approve_name = record.approve_name
					this.addForm.approve_time = record.create_at
					console.log('-addformEdit--' + JSON.stringify(this.addForm))
					console.log(record)
				})
			},
			async handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.delete({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success('操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}
</style>